import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Indian PAN validator following Single Responsibility Principle
 */
export class PanValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Indian PAN',
      pattern: /^[A-Z]{5}\d{4}[A-Z]$/i,
      length: 10
    });

    this.entityTypes = {
      'P': 'Individual',
      'C': 'Company',
      'T': 'Trust',
      'F': 'Firm/LLP',
      'A': 'Association of Persons (AOP)',
      'B': 'Body of Individuals (BOI)',
      'G': 'Government',
      'J': 'Artificial Juridical Person',
      'L': 'Local Authority',
      'H': 'Hindu Undivided Family (HUF)',
      'K': 'Krish (rarely used)'
    };
  }

  validateFormat(id) {
    const upperCaseId = id.toUpperCase();
    
    // Check length
    const lengthValidation = this.validateLength(upperCaseId, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    const patternValidation = this.validateRegex(
      upperCaseId,
      this.config.pattern,
      'PAN format must be 5 letters, 4 digits, and 1 letter'
    );
    if (!patternValidation.isValid) {
      return patternValidation;
    }

    // Validate entity type (4th character)
    const entityType = upperCaseId[3];
    if (!this.entityTypes[entityType]) {
      return ValidationResult.invalid(
        `Invalid entity type '${entityType}'. Must be one of: ${Object.keys(this.entityTypes).join(', ')}`
      );
    }

    return ValidationResult.valid();
  }

  validateChecksum(id) {
    // PAN doesn't have a mathematical checksum, but we validate the structure
    return ValidationResult.valid('Valid PAN structure');
  }

  getEntityType(id) {
    if (!id || id.length < 4) return null;
    const entityCode = id.toUpperCase()[3];
    return this.entityTypes[entityCode] || null;
  }
}